import ApiService from './api'

const TranslationService = {
    /**
     * Translate a single text.
     * @param botId Bot the translation quota is billed against
     * @param text Text to translate
     * @param language Target language code, e.g. "DE" or "EN"
     * @returns Backend translation result, or `{}` on error
     */
    getTranslation: async function (
        botId: string,
        text: string,
        language: string = "DE"
    ): Promise<any> {
        try {
            const config = {
                text,
                language
            }
            const response = await ApiService.post(`/schaltzentrale/translate/${botId}`, config);
            return response.data;
        } catch (error) {
            console.log(error);
            return {};
        }
    },

    /**
     * translate multiple texts
     *
     * @param botId Bot the translation quota is billed against
     * @param texts Texts to translate in one request
     * @param language target language
     * @returns `{error: string}` or `{data: object}`; throws on request failure
     */
    getTranslations: async function (
        botId: string,
        texts: string[],
        language: string = "DE"
    ): Promise<any> {
        try {
            const config = {
                texts,
                language
            }
            const response = await ApiService.post(`/schaltzentrale/translate-bulk/${botId}`, config);
            return response.data;
        } catch (error) {
            console.log(error);
            throw new Error("Failed to translate texts");
        }
    },

    /**
     * LLM-based translation (user auth), context-aware. Lets the engine keep the structure of the
     * payload it is given, so a list of messages comes back as a list.
     *
     * @param params.actionName Name of the action invoking the translation
     * @param params.botId Bot the translation is billed against
     * @param params.instruction Extra instructions for the translation
     * @param params.language Target language code
     * @param params.message Any payload to translate; keep it as small as possible to reduce token
     *   usage, e.g. `{ text: 'Hello' }` or `[{ text: 'Hello' }]`
     * @returns `{ success: true, data }` on success, otherwise `{ success: false, error }`
     */
    getTranslationLLM: async function ({
        actionName = '',
        botId,
        instruction = '',
        language = '',
        message,
    }: {
        actionName?: string;
        botId: string;
        instruction?: string;
        language?: string;
        message: any;
    }): Promise<{ success: boolean; data?: any; error?: any }> {
        try {
            const response = await ApiService.post(`/bot/message/translate/${botId}`, {
                actionName,
                instruction,
                language,
                message,
            });
            const data = response.data || {};

            if (data.status !== 'ok') return { success: false, error: data };
            return { success: true, data };
        } catch (error: any) {
            const err = typeof error?.response?.data === 'object' ? error.response.data : error;
            console.log(err);
            return { success: false, error: err };
        }
    },
}

export default TranslationService
